import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '@/components/auth/LoginForm';
import { useAuth } from '@/hooks/useAuth';
import { Link } from 'react-router-dom';

const Login = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect');
  const { t } = useTranslation();

  useEffect(() => {
    if (user && !loading) {
      // Si hay un redirect específico, usarlo
      if (redirectTo) {
        navigate(redirectTo);
      } else {
        navigate('/');
      }
    }
  }, [user, loading, navigate, redirectTo]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFDF9]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#B8860B]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFDF9] relative overflow-hidden px-4 py-12">
      {/* Decorative floating bubbles */}
      <div
        className="absolute top-[10%] left-[8%] w-72 h-72 rounded-full animate-float pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(184,134,11,0.06) 0%, transparent 70%)' }}
      />
      <div
        className="absolute bottom-[12%] right-[6%] w-96 h-96 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(184,134,11,0.06) 0%, transparent 70%)',
          animation: 'float 3s ease-in-out 1.5s infinite',
        }}
      />
      <div
        className="absolute top-[55%] right-[25%] w-48 h-48 rounded-full animate-float pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(212,165,38,0.05) 0%, transparent 70%)',
          animationDelay: '0.8s',
        }}
      />
      <div
        className="absolute top-[20%] right-[12%] w-36 h-36 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(184,134,11,0.04) 0%, transparent 70%)',
          animation: 'float 3s ease-in-out 2.2s infinite',
        }}
      />

      <div className="relative z-10 w-full max-w-md flex flex-col items-center">
        {/* Logo above card */}
        <Link to="/" className="flex items-center justify-center mb-8">
          <span className="font-heading text-3xl tracking-tight">
            <span className="text-[#B8860B] font-bold">Beauty</span>
            <span className="text-[#D4A526] font-bold">Book</span>
            <span className="text-[#B8860B] text-2xl font-bold">AI</span>
          </span>
        </Link>

        {/* Login card */}
        <LoginForm redirectTo={redirectTo} />

        {/* Timesheet link */}
        <div className="mt-6 text-center">
          <Link
            to="/my-timesheet"
            className="font-body text-sm text-[#8C7E6F] hover:text-[#B8860B] transition-colors"
          >
            {t('login.workerTimesheetLink')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
